<div [id]="name() + '-radio-options'" [class.inline]="inline()" class="radio-buttons">
    @for (option of options(); track option.id) {
        <div class="radio-option">
            <p-radioButton
                [inputId]="option.id"
                [name]="name()"
                [value]="option.value"
                [formControl]="control()"
                (onClick)="onClick.emit()"></p-radioButton>
            <label [for]="option.id" [class.form-label]="true">{{ option.label | translate }}</label>
            @if (option.tooltipText) {
                <info-tooltip [id]="option.id + '-info-tooltip'" [text]="option.tooltipText | translate"></info-tooltip>
            }
        </div>
    }
</div>
